import {coockiePrefix} from "../app-setting"

export const IS_LOGIN = coockiePrefix + "il";
export const DEVICE_UNIQUE_ID = coockiePrefix + "diq"
export const SESSION_KEY_ID = coockiePrefix + "ski"
export const TOKEN = coockiePrefix + "tk";
export const TOKEN_EXPIRATION_TIME = coockiePrefix + "tkex";

